import { domToDataUrl, type Options } from "modern-screenshot";
import { createApp } from "vue";

export function scrollIntoView(
  element: Element,
  options?: ScrollIntoViewOptions,
) {
  return new Promise<void>((resolve) => {
    element.scrollIntoView(options);
    let lastPos: number | null = null;
    requestAnimationFrame(checkPos);
    function checkPos() {
      const newPos = element.getBoundingClientRect().top;
      if (newPos === lastPos) {
        return resolve();
      } else {
        lastPos = newPos;
        requestAnimationFrame(checkPos);
      }
    }
  });
}

export async function renderComponentToImageDataUrl<
  Props extends Record<string, any> | null,
>(options: {
  component: Component;
  props: Props;
  setupContainer?: (container: HTMLElement) => void;
  renderOptions?: Options;
}): Promise<string> {
  const { component, props, setupContainer, renderOptions } = options;

  const divOuter = document.createElement("div");
  divOuter.style.width = "0";
  divOuter.style.height = "0";
  divOuter.style.overflow = "hidden";

  const container = document.createElement("div");
  if (setupContainer) {
    setupContainer(container);
  }
  divOuter.appendChild(container);
  document.body.appendChild(divOuter);

  const app = createApp(component, props);
  app.mount(container);

  const image = await domToDataUrl(container, renderOptions);

  document.body.removeChild(divOuter);

  return image;
}
